export default "__VITE_ASSET__kaYI$FkX__"